import { render, staticRenderFns } from "./FeedbackStatusDialog.vue?vue&type=template&id=712fa5a2&scoped=true"
import script from "./FeedbackStatusDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackStatusDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackStatusDialog.vue?vue&type=style&index=0&id=712fa5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712fa5a2",
  null
  
)

export default component.exports